export const formations = [
  {
    slug: "initiation-ia",
    number: "01",
    title: "Initiation à l'Intelligence Artificielle",
    seoTitle: "Formation Initiation à l'IA — Comprendre l'intelligence artificielle | YAFORMIS",
    metaDescription: "Formation Initiation à l'IA en présentiel ou distanciel. Comprenez les fondamentaux de l'intelligence artificielle, ses usages et ses limites. Éligible CPF.",
    tagline: "Comprendre l'IA pour l'utiliser sereinement",
    duration: "2 jours · 14h",
    level: "Débutant",
    format: "Présentiel ou distanciel",
    price: "Sur devis",
    image: "/illustrations/initiation-ia.png",
    sessions: ["19-20 janvier 2027", "16-17 février 2027", "16-17 mars 2027"],
    summary:
      "Une formation complète et accessible pour démystifier l'intelligence artificielle, comprendre son fonctionnement, identifier ses cas d'usage en entreprise et anticiper ses impacts.",
    audience: [
      "Dirigeants et entrepreneurs souhaitant comprendre les enjeux IA",
      "Salariés en reconversion ou évolution",
      "Toute personne curieuse de l'IA, sans prérequis technique",
    ],
    prerequisites:
      "Aucun prérequis technique. Maîtrise basique d'un ordinateur et d'un navigateur web.",
    objectives: [
      "Comprendre ce qu'est l'IA et ce qu'elle n'est pas",
      "Distinguer IA, machine learning et deep learning",
      "Identifier les cas d'usage concrets dans votre métier",
      "Anticiper les impacts éthiques, légaux et sociaux",
      "Adopter un vocabulaire IA précis pour communiquer",
    ],
    program: [
      {
        title: "Module 1 — Histoire et fondamentaux",
        items: [
          "Des origines de l'IA aux modèles modernes (LLM, vision, voix)",
          "Comment fonctionne un modèle d'IA : données, apprentissage, inférence",
          "Démos commentées : ChatGPT, Midjourney, Claude, Gemini",
        ],
      },
      {
        title: "Module 2 — Cas d'usage métiers",
        items: [
          "IA dans le marketing, la vente, les RH, la finance",
          "Atelier : identifier 3 cas d'usage dans votre activité",
          "Mesurer le ROI d'un projet IA",
        ],
      },
      {
        title: "Module 3 — Limites, éthique et RGPD",
        items: [
          "Hallucinations, biais, droits d'auteur",
          "RGPD et IA Act européen",
          "Construire une charte d'usage IA en entreprise",
        ],
      },
    ],
    methods: [
      "Pédagogie active : 60% pratique, 40% théorie",
      "Cas réels et démonstrations live",
      "Support PDF + replay vidéo 6 mois",
      "Évaluation par QCM + cas pratique",
    ],
    outcomes: [
      "Vocabulaire IA maîtrisé",
      "3 cas d'usage identifiés pour votre entreprise",
      "Charte d'usage IA prête à déployer",
      "Attestation de formation Qualiopi",
    ],
  },
  {
    slug: "outils-ia",
    number: "02",
    title: "Maîtriser les outils IA au quotidien",
    seoTitle: "Formation Outils IA — ChatGPT, Claude, Notion AI, Midjourney | YAFORMIS",
    metaDescription: "Formation aux outils IA professionnels : ChatGPT, Claude, Notion AI, Midjourney, Perplexity. Gagnez 10h par semaine. Éligible CPF / OPCO.",
    tagline: "Gagnez 10h par semaine grâce aux bons outils",
    duration: "3 jours · 21h",
    level: "Débutant à intermédiaire",
    format: "Présentiel ou distanciel",
    price: "Sur devis",
    image: "/illustrations/outils-ia.png",
    sessions: ["26-28 janvier 2027", "23-25 février 2027", "23-25 mars 2027"],
    summary:
      "Une formation 100% pratique pour intégrer les meilleurs outils IA dans votre quotidien professionnel et automatiser les tâches répétitives.",
    audience: [
      "Professionnels souhaitant gagner en productivité",
      "Managers, commerciaux, marketeurs, RH",
      "Indépendants et freelances",
    ],
    prerequisites:
      "Connaître ChatGPT en utilisation basique. Maîtrise de la suite bureautique (Word, Excel, PowerPoint ou équivalent).",
    objectives: [
      "Choisir le bon outil IA pour chaque tâche",
      "Rédiger des prompts efficaces (prompt engineering)",
      "Automatiser des workflows métiers avec l'IA",
      "Créer des contenus texte, image et vidéo de qualité",
      "Sécuriser l'utilisation IA en entreprise",
    ],
    program: [
      {
        title: "Module 1 — Prompt Engineering",
        items: [
          "Anatomie d'un bon prompt (rôle, contexte, contraintes, format)",
          "Techniques avancées : chain-of-thought, few-shot, prompts système",
          "Bibliothèque de 50+ prompts prêts à l'emploi",
        ],
      },
      {
        title: "Module 2 — Outils texte & recherche",
        items: [
          "ChatGPT, Claude, Gemini : forces et faiblesses",
          "Perplexity et la recherche augmentée",
          "Notion AI, Mem, Reflect pour la prise de notes",
        ],
      },
      {
        title: "Module 3 — Création visuelle et vidéo",
        items: [
          "Midjourney, DALL·E, Nano Banana pour l'image",
          "HeyGen, Synthesia, Runway pour la vidéo",
          "Bonnes pratiques droits d'auteur",
        ],
      },
      {
        title: "Module 4 — Intégration métier",
        items: [
          "GPTs et agents personnalisés",
          "Connecter l'IA à vos données (Drive, Notion, CRM)",
          "Atelier : construire votre stack IA personnelle",
        ],
      },
    ],
    methods: [
      "Ateliers 100% hands-on sur ordinateur",
      "Cas réels apportés par les stagiaires",
      "Coaching individuel inclus",
      "Évaluation par production réelle",
    ],
    outcomes: [
      "Stack IA personnelle déployée",
      "10h+ économisées par semaine",
      "Bibliothèque de prompts métier créée",
      "Attestation de formation Qualiopi",
    ],
  },
  {
    slug: "ia-generative",
    number: "03",
    title: "IA Générative — Texte, image, vidéo, voix",
    seoTitle: "Formation IA Générative — Maîtriser ChatGPT, Midjourney, Sora | YAFORMIS",
    metaDescription: "Formation IA générative avancée : LLM, image, vidéo, voix. Pour créatifs, marketeurs et formateurs. Éligible CPF.",
    tagline: "Créez 10x plus vite avec l'IA générative",
    duration: "4 jours · 28h",
    level: "Intermédiaire",
    format: "Présentiel ou distanciel",
    price: "Sur devis",
    image: "/illustrations/ia-generative.png",
    sessions: ["1-4 février 2027", "8-11 mars 2027"],
    summary:
      "Une formation approfondie sur les modèles génératifs : grands modèles de langage, génération d'image, vidéo et voix. Pour produire des contenus professionnels à grande échelle.",
    audience: [
      "Professionnels du marketing et de la communication",
      "Créatifs, designers, motion designers",
      "Formateurs et créateurs de contenu",
      "Product managers et entrepreneurs",
    ],
    prerequisites:
      "Maîtrise de ChatGPT et au moins un outil IA. Avoir suivi 'Outils IA' ou expérience équivalente recommandée.",
    objectives: [
      "Comprendre l'architecture des modèles génératifs",
      "Maîtriser la génération texte, image, vidéo et voix",
      "Construire des pipelines de production de contenu",
      "Gérer les droits, licences et marquage IA",
      "Mesurer la qualité et itérer",
    ],
    program: [
      {
        title: "Module 1 — LLM avancés",
        items: [
          "GPT-5, Claude Sonnet 4.5, Gemini 3 : comparatif",
          "Fine-tuning vs RAG vs prompts",
          "Construire un assistant métier sur vos documents",
        ],
      },
      {
        title: "Module 2 — Génération d'image pro",
        items: [
          "Midjourney v7, Nano Banana, Flux : workflows pro",
          "Cohérence de marque, style guides IA",
          "Retouche, upscaling, inpainting avancés",
        ],
      },
      {
        title: "Module 3 — Vidéo et voix",
        items: [
          "Sora 2, Runway, Veo : génération vidéo",
          "ElevenLabs, OpenAI TTS : voix de marque",
          "Lip-sync, doublage, sous-titrage automatique",
        ],
      },
      {
        title: "Module 4 — Production en série",
        items: [
          "Automatiser la génération via API",
          "Workflows Make / n8n / Zapier + IA",
          "Mesurer la qualité, A/B tester, itérer",
        ],
      },
    ],
    methods: [
      "Studio IA équipé (chaque stagiaire produit en live)",
      "Projet fil rouge : campagne complète multi-canaux",
      "Mentorat post-formation 1 mois",
      "Évaluation par projet final",
    ],
    outcomes: [
      "Campagne IA complète livrée pendant la formation",
      "Pipeline de production opérationnel",
      "Charte de style IA cohérente",
      "Attestation de formation Qualiopi",
    ],
  },
  {
    slug: "agents-ia",
    number: "04",
    title: "Création d'Agents IA autonomes",
    seoTitle: "Formation Agents IA — Créer des agents autonomes (no-code & code) | YAFORMIS",
    metaDescription: "Formation création d'agents IA autonomes. No-code et code. Automatisez vos processus métier avec des agents intelligents. Éligible CPF / OPCO.",
    tagline: "Automatisez vos processus avec des agents intelligents",
    duration: "5 jours · 35h",
    level: "Intermédiaire à avancé",
    format: "Présentiel ou distanciel",
    price: "Sur devis",
    image: "/illustrations/agents-ia.png",
    sessions: ["8-12 février 2027", "15-19 mars 2027"],
    summary:
      "La formation la plus avancée du catalogue : concevoir, déployer et superviser des agents IA capables d'agir de manière autonome sur vos systèmes.",
    audience: [
      "CTO, lead developers, ingénieurs",
      "Product managers techniques",
      "Consultants IA / automatisation",
      "Entrepreneurs tech",
    ],
    prerequisites:
      "Bases solides en IA générative. Compréhension API REST et JSON. Notions de programmation (Python ou JS) appréciées mais non obligatoires (parcours no-code disponible).",
    objectives: [
      "Concevoir l'architecture d'un agent IA fiable",
      "Implémenter en no-code (n8n, Make, Voiceflow) ou code (LangChain, CrewAI)",
      "Sécuriser les agents (guardrails, monitoring, logs)",
      "Connecter les agents à vos outils internes",
      "Mesurer la performance et itérer",
    ],
    program: [
      {
        title: "Module 1 — Architecture d'un agent",
        items: [
          "Boucle perception → décision → action",
          "Mémoire courte et longue (vector DB)",
          "Outils, fonctions, MCP : donner des capacités à l'agent",
        ],
      },
      {
        title: "Module 2 — Construire en no-code",
        items: [
          "n8n + OpenAI / Claude : workflows complexes",
          "Voiceflow et Botpress : agents conversationnels",
          "Atelier : agent commercial qui qualifie vos leads",
        ],
      },
      {
        title: "Module 3 — Construire en code",
        items: [
          "LangChain, LangGraph, CrewAI",
          "Multi-agents collaboratifs",
          "Déploiement cloud + supervision",
        ],
      },
      {
        title: "Module 4 — Sécurité et gouvernance",
        items: [
          "Guardrails : limiter les actions possibles",
          "Logs, traces, monitoring (Langfuse, LangSmith)",
          "Coûts, latence, fiabilité en production",
        ],
      },
      {
        title: "Module 5 — Projet final",
        items: [
          "Conception → développement → mise en production",
          "Soutenance devant jury",
          "Plan de déploiement en entreprise",
        ],
      },
    ],
    methods: [
      "Lab technique avec environnement cloud fourni",
      "Code review individuelle",
      "Pair programming et revues d'architecture",
      "Évaluation par projet déployé en production",
    ],
    outcomes: [
      "Agent IA déployé en production sur votre stack",
      "Architecture d'agents maîtrisée",
      "Plan de gouvernance IA complet",
      "Certificat YAFORMIS · attestation Qualiopi",
    ],
  },
];

export const getFormationBySlug = (slug) => formations.find((f) => f.slug === slug);
